import Accordion from "./Accordion";

export default {
    init() {
        if (document.querySelector('.section--generic-accordion .accordion')) {
            Array.from(document.querySelectorAll('.section--generic-accordion .accordion'))
                .forEach(el => {
                    el.accordion = new Accordion(el);
                });
        }
    }
}
